import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import itemEditor from './_item_editor_component';
import commonHeader from './_common_header_component';
import preview from './_preview_component';
import staticHtmlEditor from '../../components/static_html_editor/_index';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import modalUpdateCategoryConfirm from '../../components/category/_modal_update_category_confirm';
import modalItemDeployed from './_modal_item_deployed';
import modalReservationDatetimeEditor from '../../components/deploy/_modal_reservation_datetime_editor';

// 各エリア定義
const AREAS_DATA = [
    {
        key: 'additional_config',
        name: '商品情報フリースペース',
        width: 946,
    },
];

/**
 * 商品編集ページ共通mixin
 */
export default {
    data () {
        return {
            // 編集ID
            edit_id: null,
            // 商品データ
            item_data: {},
            // 文字数オーバーメッセージ表示フラグ
            over_text_length: false,
            // 反映方法
            deploy_mode: 'normal',
        };
    },
    components: {
        // 共通ヘッダーコンポーネント
        'common-header': commonHeader,
        // 商品情報編集コンポーネント
        'item-editor': itemEditor,
        // 静的HTML編集コンポーネント
        'static-html-editor': staticHtmlEditor,
        // ヤフーAPIトークン認証チェックコンポーネント
        'modal-yahoo-auth': modalYahooAuth,
        // カテゴリ更新を促すモーダル
        'modal-update-category-confirm': modalUpdateCategoryConfirm,
        // アイテム登録完了時モーダル
        'modal-item-deployed': modalItemDeployed,
        // プレビューコンポーネント
        'preview': preview,
        // 予約日時選択コンポーネント
        'modal-reservation-datetime-editor': modalReservationDatetimeEditor,
    },
    computed: {
        // 各エリア定義
        areasConfig: function () {
            return AREAS_DATA;
        },
        // 編集ページか否か
        isEditItem: function () {
            return (this.$_params('item_code') !== null);
        },
        // テンプレート
        template: {
            get() {
                return {
                    additional_config: this.item_data['additional_config'],
                    sp_additional_config: this.item_data['sp_additional_config'],
                };
            },
            set(value) {
                this.item_data['additional_config'] = value['additional_config'];
                this.item_data['sp_additional_config'] = value['sp_additional_config'];
            },
        },
        // 連動フラグ
        device_sync: function () {
            return this.item_data['device_sync'];
        },
        // 商品画像・商品詳細画像の一覧を取得
        imagesConfig: function () {
            return {
                image_config: this.item_data['image_config'],
                lib_images_config: this.item_data['lib_images_config'].reduce((arr, data) => (data && data['image'] ? [ ...arr, data['image'] ] : arr), [])
            };
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        chromeExtensionMixin,
        deployReservationCheck,
    ],
    watch: {
        // step変更時、スクロールをトップへ戻す
        step: function () {
            window.scroll(0, 0);
        }
    },
    created: function () {
        // 編集IDをセット
        this.setEditId();
    },
    methods: {
        // 編集IDをセット
        setEditId: function (editId = null) {
            this.edit_id = (editId) ? editId : moment().unix();
            console.log('edit_id: ' + this.edit_id);
        },
        // 商品コードを個別コードの接頭語として付与させる
        prefixItemCode: function (itemData) {
            // 編集時、通常在庫の時は付与しない
            if (this.isEditItem || itemData.stock_config.type === 'normal') {
                return itemData;
            }

            itemData = _.cloneDeep(itemData);
            let values = itemData.subcodes_config.values;
            for (const rowIndex in values) {
                for (const colIndex in values[rowIndex]) {
                    // 文字列として商品、個別コードを結合させる為、先頭に空文字列を入れる
                    values[rowIndex][colIndex].code = '' + itemData.item_code + values[rowIndex][colIndex].code;
                }
            }
            itemData.subcodes_config.values = values;
            return itemData;
        },
        // 下書き商品を取得
        setDraftItem: async function (editId, copyDstId = null) {
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await axios.get('/item/get_draft_item', {
                    params: {
                        edit_id: editId,
                        copy_dst_id: copyDstId, // コピー先の編集ID(this.edit_id)
                    }
                });
                if (response.data.status == 'OK') {
                    // 商品データをセット
                    this.item_data = response.data.data;
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
        // 公開済みデータをセット
        setItemData: async function (itemCode, isCopy = 0) {
            let message = this.exception_error_message;
            let success = false;
            this.$_loading();
            try {
                const response = await axios.get('/item/get_released_item', {
                    params: {
                        item_code: itemCode,
                        is_copy: isCopy,
                    }
                });
                if (response.data.status == 'OK') {
                    // 商品データをセット
                    this.item_data = response.data.data;
                    success = true;
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
            return success;
        },
        /**
         * 反映
         * 
         * @param {bool} $shouldDeploy
         * @param {string|null} $reserve_time
         */
        deploy: async function (shouldDeploy = true, reserve_time = null) {
            // フラッシュメッセージを初期化
            this.clearFlashMessage();
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await yahooAxios.post('/item/deploy', {
                    edit_id       : this.edit_id,
                    copy_id       : this.$_copyId(),
                    item_data     : this.prefixItemCode(this.item_data),
                    should_deploy : shouldDeploy,
                    reserve_time  : reserve_time,
                    is_edit       : this.isEditItem,
                });
                // 成功
                if (response.data.status === 'OK') {
                    if (response.data.message !== '') {
                        // 成功はしたがメッセージがある場合
                        message = response.data.message;
                    } else {
                        // エラーメッセージを空にする
                        message = '';
                    }
                    // 反映モードを更新
                    if (reserve_time !== null) {
                        this.deploy_mode = 'reserve';
                    } else if (!shouldDeploy) {
                        this.deploy_mode = 'private';
                    } else {
                        this.deploy_mode = 'normal';
                    }
                    // アイテム登録完了モーダルを開く
                    await this.$refs.modal_item_deployed.itemDeployed(this.item_data.item_code);
                    // editedフラグをfalseにして未変更状態に
                    this.$root.$refs.commonHeader.updateEdited(false);
                // 失敗
                } else {
                    console.log(response);
                    message = response.data.message;
                    // 商品情報入力画面に戻す
                    this.step--;
                }
            } catch (e) {
                await this.$root.$refs.yahooAuth.error(e);
                message = '';
                // 商品情報入力画面に戻す
                this.step--;
            } finally {
                this.$_unloading();
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            }
        },
        // 今すぐ反映
        deployAtOnce: async function (shouldDeploy = true) {
            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                // 予約あり & 反映あり
                if (existsReservation && shouldDeploy) {
                    if (await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。このまま進むと、予約中の更新も同時に反映されますが、よろしいでしょうか？')) {
                        this.deploy(shouldDeploy);
                    }
                    return;
                }
                // 予約なし or 反映なし
                this.deploy(shouldDeploy);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            }
        },
        // 反映を予約
        reserveDeploy: async function () {
            try {
                // 予約存在をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    if( await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。今回の更新内容を、こちらの予約へ追加します。')) {
                        this.deploy(false);
                    }
                    return;
                }
                // 予約なし
                this.$refs.modalReservationDatetimeEditor.open();

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            }
        },
    }
};
